import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../../common/assets/logo/logo-h-white.svg';
import styles from './styles.module.scss';

const FirmLogo = ({className}) => (
  <img
    src={logo}
    alt="logo"
    className={`${styles.logo} ${className}`}
  />
);

FirmLogo.propTypes = {
  className: PropTypes.string
};

export default FirmLogo;
